<template>
  <div class="Menu">
    <div
      :class="currentIndex == index ? 'content_ac' : ''"
      class="content"
      v-for="(item, index) in dataList"
      :key="index"
      @click="clickItem(item, index)">
      <img class="img" :src="item.imgUrl" />
      <div class="text">{{ item.name }}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'Menu',
  computed: {
    ...mapState(['topic', 'sceneWeather']),
    chineseName() {
      let data = this.weathers;
      return Object.keys(data).find((item) => data[item] === this.sceneWeather);
    }
  },
  props: {
    dataList: {
      type: Array,
      default: [
        {
          name: 'Vessels In Port',
          highLight: 'VesselsInPort',
          imgUrl: require('../../assets/img/commonComponents/VesselsInPort.png')
        },
        {
          name: 'Crane Equipment',
          highLight: 'CraneEquipment',
          imgUrl: require('../../assets/img/commonComponents/CraneEquipment.png')
        },
        {
          name: 'Gantry Crane',
          highLight: 'GantryCrane',
          imgUrl: require('../../assets/img/commonComponents/GantryCrane.png')
        }
      ]
    }
  },
  data() {
    return {
      currentIndex: -1
    };
  },
  watch: {},
  methods: {
    clickItem(item, index) {
      if (this.currentIndex == index) {
        this.currentIndex = -1;
      } else {
        this.currentIndex = index;
        this.$store.commit('setHighLight', item.highLight);
      }
      this.$emit('clickItem', item, this.currentIndex);
    }
  }
};
</script>

<style lang="less" scoped>
.Menu {
  position: relative;
  display: flex;
  pointer-events: all;
  flex-direction: column;
  width: 340px;
  position: absolute;
  bottom: 20px;
  .content {
    display: flex;
    width: 340px;
    height: 80px;
    background: url('../../assets/img/commonComponents/btn_bg.png');
    align-items: center;
    justify-content: space-evenly;
    margin-top: 20px;
    .img {
      width: 32px;
      height: 32px;
    }
    .text {
      width: 230px;
      font-family: 'Helvetica';
      font-size: 28px;
      color: #ffffff;
    }
  }
  .content_ac {
    background: url('../../assets/img/commonComponents/btn_bg_ac.png');
  }
  .select_left {
    width: 90px;
    position: absolute;
    left: 0px;
    top: 0px;
    line-height: 28px;
  }
  & div.select-options,
  & div.selected-area {
    position: relative;
    width: 160px;
    height: 35px;
    margin-right: 8px;
    line-height: 35px;
    text-align: center;
    // border: 1px solid #1fbbef;
    // background-image: linear-gradient(to bottom, #ffffff, #c5fcf3);
    color: #ccc;
    -webkit-background-clip: text;
  }
  & div.select-options {
    width: 110px;
    height: 30px;
    margin-right: 12px;
    background: #0d2033;
    display: flex;
    & div.down-select {
      position: absolute;
      height: 100%;
      width: 18px;
      right: 0px;
      // border-left: 1px solid #1fbbef;
      transition: all 0.6s;
      & span.downicon {
        position: absolute;
        border-top: 4px solid transparent;
        border-right: 4px solid transparent;
        border-left: 4px solid #1fbbef;
        border-bottom: 4px solid #1fbbef;
        transform: translate(-4px, 16px) rotate(135deg);
      }
      & span.downiconUp {
        position: absolute;
        border-top: 4px solid transparent;
        border-right: 4px solid transparent;
        border-left: 4px solid #1fbbef;
        border-bottom: 4px solid #1fbbef;
        transform: translate(-4px, 12px) rotate(-45deg);
      }
    }
    & ul.down-aren {
      width: 100%;
      position: relative;
      bottom: -33px;
      left: 0;
      height: 245px;
      overflow: auto;
      // border: 1px solid #1fbbef;
      & li.item {
        background: rgba(#0d2033, 0.8);
        border: 1px solid rgba(#0d2033, 0.1);
        user-select: none;
        &:not(:first-of-type) {
          border-top: none;
        }
        &:hover {
          color: #00ffff;
          background: rgba(#1fbbef, 0.7);
        }
      }
    }
  }
  & div.selected-area {
    background: rgba(#1fbbef, 0.3);
    &::before {
      position: absolute;
      left: -10px;
      display: inline-block;
      content: '';
      border-top: 4px solid #fff;
      border-right: 4px solid #fff;
      border-left: 4px solid transparent;
      border-bottom: 4px solid transparent;
      transform: translate(-4px, 10px) rotate(45deg);
    }
  }
  // 主题颜色
  .b1 {
    border-left: 1px rgb(37, 138, 239) solid;
  }
  .b2 {
    border-left: 1px rgb(22, 180, 248) solid;
  }
  .b3 {
    border-left: 1px rgb(13, 200, 130) solid;
  }
  .b4 {
    border-left: 1px rgb(222, 189, 88) solid;
  }
  .b5 {
    border-left: 1px rgb(244, 149, 43) solid;
  }
  .b6 {
    border-left: 1px rgb(33, 243, 243) solid;
  }
  .b7 {
    border-left: 1px rgb(165, 187, 4) solid;
  }
  .ac1 {
    border: 1px rgb(37, 138, 239) solid;
    // background-color: rgba(37, 138, 239, 0.2);
  }
  .ac2 {
    border: 1px rgb(22, 180, 248) solid;
    // background-color: rgba(22, 180, 248, 0.2);
  }
  .ac3 {
    border: 1px rgb(13, 200, 130) solid;
    // background-color: rgba(13, 200, 130, 0.2);
  }
  .ac4 {
    border: 1px rgb(222, 189, 88) solid;
    // background-color: rgba(222, 189, 88, 0.2);
  }
  .ac5 {
    border: 1px rgb(244, 149, 43) solid;
    // background-color: rgba(244, 149, 43, 0.2);
  }
  .ac6 {
    border: 1px rgb(33, 243, 243) solid;
    // background-color: rgba(33, 243, 243, 0.2);
  }
  .ac7 {
    border: 1px rgb(165, 187, 4) solid;
    // background-color: rgba(165, 187, 4, 0.2);
  }
}
</style>
